import { render } from "./JobFeedbackOpenClose.vue?vue&type=template&id=f0a25da8"
import script from "./JobFeedbackOpenClose.vue?vue&type=script&lang=js"
export * from "./JobFeedbackOpenClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__